var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-2 pa-md-12"},[_c('v-alert',{staticClass:"headline",attrs:{"type":"error","text":"","border":"left"}},[_vm._v(" Une erreur est survenue lors du paiement. Veuillez vous assurer que le montant du don est supérieur à 10$ et que le code postal indiqué correspond à celui de votre carte de crédit. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }